const WIKDICT_CHUNK_CACHE_NAME = "language-matchup-wikdict-chunks-v1";

const fetchChunkFromNetwork = async (chunkPath) => {
    const response = await fetch(chunkPath);
    if (!response.ok) {
        throw new Error(`Failed to fetch WikDict chunk: ${chunkPath}`);
    }
    return response;
};

export const loadCachedWikDictChunk = async (chunkPath) => {
    if (typeof window !== "undefined" && "caches" in window) {
        const cache = await window.caches.open(WIKDICT_CHUNK_CACHE_NAME);
        let response = await cache.match(chunkPath);

        if (!response) {
            response = await fetchChunkFromNetwork(chunkPath);
            await cache.put(chunkPath, response.clone());
        }

        return response.json();
    }

    const response = await fetchChunkFromNetwork(chunkPath);
    return response.json();
};
